export const REQUEST_GETVIDEO = 'REQUEST_GETVIDEO';
export const GETVIDEO_RECEIVED = 'GETVIDEO_RECEIVED';
